import { render, staticRenderFns } from "./egames.vue?vue&type=template&id=3d3de207&lang=pug&"
import script from "./egames.vue?vue&type=script&lang=js&"
export * from "./egames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports